// removed by extract-text-webpack-plugin
module.exports = {"component":"_348dLXumxUi5IgCI4liiOF","message":"qv7WCBq2POApxXWsYRLEk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Account/FamilyAccess/FamilyAccess.css
// module id = 1465
// module chunks = 0